import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { map, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export const accessGuard: CanMatchFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Use the observable to ensure we have the latest user state
  return authService.gigyaUser$.pipe(
    take(1),
    map(userDetails => {
      // Check if user is not logged in (empty object or no accessIdentifier)
      const isNotLoggedIn = !userDetails || Object.keys(userDetails).length === 0 || !userDetails.accessIdentifier;
      if(!environment.production) {
        console.log('Logged In Details', isNotLoggedIn);
      }
      // Allow access if not logged in OR has INDADMIN role
      if(isNotLoggedIn || userDetails.accessIdentifier === 'INDADMIN') {
        return true;
      } else {
        // User is logged in but doesn't have INDADMIN role
        router.navigateByUrl('/home');
        return false;
      }
    })
  );
};